var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { auth } from '../firebase';
import { getApiBaseUrl } from './apiMode';
export class ApiError extends Error {
    constructor(status, code, message, details) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.code = code;
        this.details = details;
    }
}
const DEFAULT_TIMEOUT = 30000;
/**
 * Returns true when the active data path is REST — i.e. the runtime mode resolves to an API
 * base URL for this hostname. False means the services take their direct Firestore branch.
 * See apiMode.ts for the switch itself.
 */
export function isRestApiMode() {
    return !!getApiBaseUrl();
}
function getBaseUrl() {
    return getApiBaseUrl();
}
function request(method, path, body, params) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const baseUrl = getBaseUrl();
        const url = new URL(`${baseUrl}${path}`);
        if (params) {
            Object.entries(params).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    url.searchParams.set(key, String(value));
                }
            });
        }
        const token = yield ((_a = auth.currentUser) === null || _a === void 0 ? void 0 : _a.getIdToken());
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), DEFAULT_TIMEOUT);
        try {
            const response = yield fetch(url.toString(), {
                method,
                headers: Object.assign({ 'Content-Type': 'application/json' }, (token && { Authorization: `Bearer ${token}` })),
                body: body ? JSON.stringify(body) : undefined,
                signal: controller.signal,
            });
            clearTimeout(timeoutId);
            if (!response.ok) {
                const errorBody = yield response.json().catch(() => ({}));
                const error = errorBody.error || {};
                throw new ApiError(response.status, error.code || 'UNKNOWN', error.message || response.statusText, error.details);
            }
            if (response.status === 204) {
                return undefined;
            }
            return yield response.json();
        }
        catch (error) {
            clearTimeout(timeoutId);
            if (error instanceof ApiError)
                throw error;
            if (error instanceof DOMException && error.name === 'AbortError') {
                throw new ApiError(408, 'TIMEOUT', 'Request timed out');
            }
            throw error;
        }
    });
}
export const apiClient = {
    get: (path, params) => request('GET', path, undefined, params),
    post: (path, body) => request('POST', path, body),
    put: (path, body) => request('PUT', path, body),
    patch: (path, body) => request('PATCH', path, body),
    delete: (path, body) => request('DELETE', path, body),
};
